export const testSQ = `#version 300 es
precision highp float;
#define PI 3.14159265359
uniform vec2 u_resolution;
uniform float u_time, u_siize;
out vec4 final;

float map(float value, float min1, float max1, float min2, float max2) {
   return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
   }


float rectshape(vec2 position,vec2 scale){
   scale=vec2(.5)-scale*.5;
   vec2 shaper=vec2(step(scale.x,position.x),step(scale.y,position.y));
   shaper*=vec2(step(scale.x,1.-position.x),step(scale.y,1.-position.y));
   return shaper.x*shaper.y;}
   
void main(){

vec3 c1 = vec3(u_siize, u_siize*.5, 0.9333-u_siize);
vec3 c2 = vec3(0.6941, 0.102, 0.2588*sin(u_time*0.00015));
vec3 c22 = vec3(0.549*sin(u_time*0.00015), 0.298, 0.6);
vec3 c3 = vec3(0.0471, 0.0039, 0.0392);
float delta = sin(u_time*0.00015)+1.0/2.;
float h0 = u_siize;
float h = map(h0*tan(u_time*0.0005),-1.0, 1.0, 0.1, 1.0);
float h3 = map(u_siize, 0.0, 1.0, 0.15, 0.155);
float h4 = map(h0*tan(u_time*0.0005), -1.0, 1.0, 0.1, 0.9);
vec2 translate = vec2(0.0,h3);


   vec2 position=gl_FragCoord.xy/u_resolution;
   vec3 color=vec3(0.0, 0.0, 0.0);
//    position += translate;
   vec3 colorForRectTwo=vec3(0.9, 0.9, 0.9);

   // vec3 colorForRectTwo=mix(vec3(0.9, 0.33, 0.45), vec3(0.65,0.33,0.17), position.y * sin(u_time*0.0005));
   c1 = mix(c1,vec3(0.0),(tan(u_time*0.00005)));
   c22 = mix(c22,vec3(0.0), (tan(u_time*0.00005)));
   vec3 color2=c22;
   float rectangle=rectshape(position ,vec2(0.15,0.15));
   float rectangleTwo=rectshape(position  ,vec2(h,h4));
   

                  

//    color=color*(rectangle);
  // color2=color2*color;
    
   if (rectangle > 0.0) {
       color2 = c1;
   }
   
   // if (rectangleTwo > 0.0) {
   //     color2 = c3;
   // }

//    color2 -= (rectangle-rectangleTwo);
    
   final=vec4(color2,1.);
}`